import * as actions from './action';

const init = {
  menuCollapsed: false,
  loading: false,
  authLoading: true,
  headerMenu: 'header_tab_growz',
};

export default (state = init, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actions.MENU_TOGGLE:
      newState.menuCollapsed = action.state;
      break;
    case actions.HEADER_MENU_TOGGLE:
      newState.headerMenu = action.payload;
      break;
    case actions.SET_PAGE_LOADER:
      newState.loading = true;
      break;
    case actions.REMOVE_PAGE_LOADER:
      newState.loading = false;
      break;
    case actions.SET_AUTH_LOADER:
      newState.authLoading = true;
      break;
    case actions.REMOVE_AUTH_LOADER:
      newState.authLoading = false;
      break;
    default:
  }
  return newState;
};
